/**
 * To enable the view use data-view="form". Please note that the form view needs to have is root on a form element.
 * example:
 * <form class="component" data-view="form"></form>
 */

/* Looking for a quick way to fill in the form with test data? Try this!

    $('input[type="text"]:not(#userForm\\.phoneNumber),input[type="password"]').val('test test');
    $('#userForm\\.phoneNumber,#userForm\\.accountNumber').val('1234567890');
    $('#userForm\\.email').val('test@test.com');
    $('#terms-of-use-agreement').prop('checked', 'checked');
*/

(function (ws) {
    'use strict';
    ws.views.getAccessView = ws.views.form.extend({

        mainError: '.form-main-error',

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'user',
        GTM_EVENT_ACTION: 'registration',
        GTM_EVENT_ACTION_SUCCESS: 'registration_success',
        GTM_EVENT_ACTION_FAIL: 'registration_failure',

        MAX_ACCOUNT_NUMBER_LENGTH: 10,

        /**
         * The primary job function, updated when the radio buttons
         * in the access-level component get selected.
         *
         * @property {string}
         */
        primaryJobFunction: '',

        /**
         * Run Additional Validation On Errors
         */
        additionalValidationOnErrors: true,

        /**
         * Loads the value of job description at document load
         */
        initialize: function() {
            ws.views.form.prototype.initialize.call(this);

            // define event aggregation
            this.eventAgg = globals.eventAgg;

            if (this.$('input[name="accountNumber"]').val() === 'DummyUnit') {
                this.$('input[name="accountNumber"]').val('');
            }

            //check Synnex Country
            this.checkSynnexCountryModel = new ws.models.accessSynnexCountryCheckModel();
            this.$country = this.$('#country');
            this.$phoneNumber = this.$('#userForm\\.phoneNumber');
            this.$phoneNumberCountryCode = this.$('#countryCode');
            this.$accessLevel = this.$('.comp-access-level');
            this.$accountNumber = this.$('#userForm\\.accountNumber');
            this.$accountNumberErrors = this.$('#accountNumberErrors');
            this.$jobDescription = this.$('#jobdescription');
            this.$termsCheckbox = this.$('.chkBoxTerm');
            this.$termsError = this.$('.gta-terms-error');

            this.listenTo(this.eventAgg, 'selectPrimaryJobFunction', this.setPrimaryJobFunction.bind(this));

            this.setSalesOrg();
            this.countryJobsOptions();

            this.helpInlineCollection = $('#userForm').find('.help-inline').toArray();
            if (this.helpInlineCollection) {
                this.highlightInputForCustomError(this.helpInlineCollection);
            }
        },

        /**
         * Extend generic form events
         */
        events: _.extend({}, ws.views.form.prototype.events, {
            'change input': 'resetField',
            'change .country-select': 'onCountryChange',
            'change .jobs-select': 'showJobDescription',
            'change .chkBoxTerm': 'checkTextBoxes',
            'change #countryCode': 'changeCountryCode',
            'change #globalVarCustomer': 'updateCheckboxVal',
            'change .confirmEmail': 'checkForSameEmails',
            'change .email': 'checkEmailForTelstra'
        }),

        // Global customer var fn

        updateCheckboxVal: function(e) {
            if (e.target.value === 'on') {
                $(e.target).val(true);
            } else {
                $(e.target).val(false);
            }
        },

        /**
         * Remove empty option from country code dropdown
         * when user selects a valid value
         * @param {Event} e
         */
        changeCountryCode: function (e) {
            const checkedValue = e.currentTarget.value;
            if (checkedValue) {
                this.removeEmptyOptionFromDropdown();
            }
        },

        /**
         * Remove empty option from country code dropdown
         */
        removeEmptyOptionFromDropdown: function () {
            this.$phoneNumberCountryCode.find('option[value=""]').remove();
        },

        /**
         * Sets the primary job function.
         *
         * @param {string} primaryJobFunction
         */
        setPrimaryJobFunction(primaryJobFunction) {
            this.primaryJobFunction = primaryJobFunction;
        },

        /**
         * Additional field validations
         */
        additionalValidation() {
            this.error = false;
            this.checkEmail();
            this.checkForSameEmails();
            this.checkCompanyName();
            this.checkPhone();
            this.checkTextBoxes();
            this.validateAccountNumbers();
            this.checkPrimaryJobFunction();
        },

        /**
         * Override default error function
         */
        checkTextBoxes() {
            this.$termsError.toggle(false);

            if (!this.$termsCheckbox.is(':checked')) {
                this.error = true;
                this.$termsError.toggle(true);
            }
        },

        /**
         * Check Primary Job Error
         */
        checkPrimaryJobFunction() {
            // first check if the access level radio buttons are visible
            if (this.accessLevelRadioButtonsVisible) {
                // then run validation
                if (this.primaryJobFunction === '') {
                    this.error = true;

                    // and trigger error handler
                    this.eventAgg.trigger('accessLevelError');
                }
            }
        },

        /**
         *Company name Error message
         */
        checkCompanyName() {
            if ($('.userFormCompanyName').val().trim() === '') {
                this.error = true;
            } else {
                this.error = false;
            }
        },

        /**
         *Email Error message
         */
        checkForSameEmails: function() {
            if ($('.email').val().trim() !== $('.confirmEmail').val().trim()) {
                $('.custom-validation-error-message').show();
                $('.confirmEmail').addClass('error');
                this.error = true;
            } else {
                $('.custom-validation-error-message').hide();
                $('.confirmEmail').removeClass('error');
                this.error = false;
            }
        },

        /**
         * Reset field with error message
         */
        resetField(e) {
            var $el = $(e.target);
            $el.removeClass(this.errorClass);
            $el.nextAll(this.errorMsg).hide();
            $el.nextAll(this.customErrorMsg).hide();
            $el.parents('.controls').next('.help-inline').hide();
        },

        /**
         * Actions On Country Change
         * @param {Event} e
         */
        onCountryChange(e) {
            this.setSalesOrg();
            this.countryClearOption(e);
            this.countryJobsOptions();
            this.checkSynnexCountry();
            this.updatePhoneCountryCode();
            this.checkEmailForTelstra();
        },

        /**
         * Set Current Sales Org
         */
        setSalesOrg() {
            this.salesOrg = this.$country.find('option:selected').data('salesorg');
        },

        /**
         * Set Current Country
         */
        setCountry() {
            let url = window.location.pathname.split('/');
            let countryCode = url[url.length - 4];
            if (countryCode.length === 2) {
                this.$country.val(countryCode);
            }
        },

        /**
         * Clear first country empty option after country selection
         * @param {Event} e - event
         */
        countryClearOption(e) {
            if (e.currentTarget.value) {
                $(e.currentTarget).find('option[value=""]').remove();
            }
        },

        checkEmailForTelstra: function () {
            $('.getAccessSubmit').attr('disabled', false);
            $('.blocksubmission').addClass('hide');
            $('.prevList').hide();
            let emailUsed = $('.email').val().split('@')[1] ? $('.email').val().split('@')[1] : $('.email').val().split('@')[0];
            let isTelstraEmail = emailUsed.toLowerCase().includes('telstra');
            if (isTelstraEmail && $('#country').val() != '') {
                $('.telstra-optn').show();
                this.toggleAccessLevel(true);
            } else if ($('#country').val() != '') {
                $('.telstra-optn').hide();
                if (!$('.comp-access-level .level .option:visible').length) {
                    this.toggleAccessLevel(false);
                    if (emailUsed != '') {
                        $('.getAccessSubmit').attr('disabled', true);
                        $('html, body').animate({ scrollTop: 0 }, 'slow');
                        $('.blocksubmission').removeClass('hide');
                    }
                }
            }
        },

        /**
         * Set Job Description
         */
        countryJobsOptions() {
            var primaryJobSelect = $('#primaryJobFunction');
            var primaryJobData = primaryJobSelect.data('attr');
            var country = $('#country').val();
            var arrayJobData = [];
            var option = _.template('<option data-text="<@= item.displayText @>" value="<@= item.code @>"><@= item.name @></option>');
            $('.prevList').hide();

            // check if country exists in data
            if (country in primaryJobData) {

                // then check if country data not empty
                if (primaryJobData[country].length) {
                    this.toggleAccessLevel(false);
                    const _this = this;

                    // update job options
                    _.each(primaryJobData[country], function (item) {
                        if (item.newAccessLevelConfig) {
                            _this.toggleAccessLevel(true);
                        }

                        if (item.prospectOnboardEnabled) {
                            $('.newPrimary').show();
                        } else {
                            $('.newPrimary').hide();
                        }

                        if (item.enableMasterAgent) {
                            $('.master-agent').show();
                        } else {
                            $('.master-agent').hide();
                        }

                        if (item.enableAcademyPartner) {
                            $('.isAcademyPartner').show();
                        } else {
                            $('.isAcademyPartner').hide();
                        }

                        if (item.prospectReburaOnboardEnabled) {
                            $('.isReburaPartner').show();
                        } else {
                            $('.isReburaPartner').hide();
                        }

                        arrayJobData.push(option({item: item}));
                    });
                } else {
                    $('.newPrimary').hide();
                    $('.master-agent').hide();
                    $('.isAcademyPartner').hide();
                    $('.isReburaPartner').hide();
                    this.toggleAccessLevel(false);
                }
            }

            primaryJobSelect.empty();
            primaryJobSelect.append(arrayJobData);
            this.showJobDescription();
        },

        /**
         * Toggle Access Level
         */
        toggleAccessLevel(toggle) {
            this.$('.comp-access-level').toggle(toggle).find('input').prop('disabled', !toggle);
            this.$('.primaryJobFunction').css('display', 'none').find('select').prop('disabled', true);
            this.accessLevelRadioButtonsVisible = toggle;
            this.$jobDescription.toggle(!toggle);
        },

        /**
         * Updates the phone country code based on the selected country
         * if the phone number has not been entered yet.
         */
        updatePhoneCountryCode() {
            const isPhoneNumberModified = this.$phoneNumber.val().trim() !== '';
            const isPhoneNumberCountryCodeModified = this.$phoneNumberCountryCode.val().trim() !== '';

            if (!isPhoneNumberModified || (isPhoneNumberModified && !isPhoneNumberCountryCodeModified)) {
                this.$phoneNumberCountryCode
                    .val(this.$country.find('option:selected').data('countryCode'))
                    .trigger('change');
                this.removeEmptyOptionFromDropdown();
            }
        },

        /**
         * Check for Synnex country redirection based on the selected country
         */
        checkSynnexCountry() {
            this.checkSynnexCountryModel.set('countryIsocode', this.$country.find('option:selected').val());
            this.checkSynnexCountryModel.checkSynnexRedirectRequirement();
        },

        /**
         * Show Description
         */
        showJobDescription() {
            this.$jobDescription.html($('#primaryJobFunction :selected').data('text'));
        },

        /**
         * Validates & formats the account number[s].
         */
        validateAccountNumbers() {
            /**
             * Gets duplicates by looking for exact matches and similar matches.
             * Expects that all values in the unformattedNumbers array correspond
             * on a 1:1 basis with the values in the formattedNumbers array.
             *
             * @param {string[]} unformattedNumbers - The original values entered by the user.
             * @param {string[]} formattedNumbers - The properly-formatted values entered by the user.
             * @returns {{exactMatches: string[], similarMatches: *[]}} - All exact and similar matches.
             */
            function getDuplicates(unformattedNumbers, formattedNumbers) {
                const duplicates = {
                    exactMatches: [],
                    similarMatches: []
                };

                // Compare every number to every other number,
                // looking for exact duplicates only
                for (let i = 0; i < unformattedNumbers.length - 1; i++) {
                    for (let j = i + 1; j < unformattedNumbers.length; j++) {
                        // Check for already-existing matches; we have to do this
                        // so we don't display the same match multiple times
                        if (unformattedNumbers[i] === unformattedNumbers[j] && duplicates.exactMatches.indexOf(unformattedNumbers[i]) === -1) {
                            duplicates.exactMatches.push(unformattedNumbers[i]);
                        }
                    }
                }

                // Compare every number to every other number,
                // looking for non-exact duplicates only
                for (let i = 0; i < formattedNumbers.length - 1; i++) {
                    const similarMatches = {
                        formattedMatch: undefined,
                        originalMatches: []
                    };
                    for (let j = i + 1; j < formattedNumbers.length; j++) {
                        if (formattedNumbers[i] === formattedNumbers[j]) {

                            /* jshint ignore:start */

                            // Check for already-existing matches; we have to do this
                            // so we don't display the same match multiple times
                            //
                            // Also, ignore this line
                            // because ghetto JSHint hates arrow functions. :-/
                            const duplicateIndex = _.findIndex(duplicates.similarMatches, similarMatch => similarMatch.formattedMatch === formattedNumbers[j]);

                            /* jshint ignore:end */

                            if (duplicateIndex === -1) {
                                similarMatches.formattedMatch = formattedNumbers[i];

                                // Check for already-existing matches; we have to do this
                                // so we don't display the same match multiple times
                                if (similarMatches.originalMatches.indexOf(unformattedNumbers[i]) === -1) {
                                    similarMatches.originalMatches.push(unformattedNumbers[i]);
                                }

                                // Check for already-existing matches; we have to do this
                                // so we don't display the same match multiple times
                                if (similarMatches.originalMatches.indexOf(unformattedNumbers[j]) === -1) {
                                    similarMatches.originalMatches.push(unformattedNumbers[j]);
                                }
                            }
                        }
                    }

                    // If we found any matches, add them to the list
                    if (similarMatches.formattedMatch !== undefined) {
                        duplicates.similarMatches.push(similarMatches);
                    }
                }

                return duplicates;
            }

            let text = this.$accountNumber.val().trim();
            if (text !== '') {
                const accountNumbers = text.split(',').map(num => num.trim());
                const unformattedAccountNumbers = [];
                const formattedAccountNumbers = [];
                const errors = [];
                const onlyDigits = new RegExp(/^[0-9]+$/);

                accountNumbers.forEach(accountNumber => {
                    // Check for only numbers
                    if (!onlyDigits.test(accountNumber)) {
                        errors.push(this.$accountNumberErrors.data('errorNotANumber')
                            .replace('{number}', accountNumber)
                        );
                    }
                    else {
                        // Check for numbers that are too long
                        let formattedAccountNumber = parseInt(accountNumber, 10).toString();
                        if (formattedAccountNumber.length > this.MAX_ACCOUNT_NUMBER_LENGTH) {
                            errors.push(this.$accountNumberErrors.data('errorNumberTooLong')
                                .replace('{number}', accountNumber)
                            );
                        }
                        else {
                            unformattedAccountNumbers.push(accountNumber);
                            formattedAccountNumber = '0'.repeat(this.MAX_ACCOUNT_NUMBER_LENGTH - formattedAccountNumber.length) + formattedAccountNumber;
                            formattedAccountNumbers.push(formattedAccountNumber);
                        }
                    }
                });

                // Check for duplicates and apply errors if found
                const { exactMatches, similarMatches } = getDuplicates(unformattedAccountNumbers, formattedAccountNumbers);

                // Add errors for exact matches
                exactMatches.forEach(exactMatch => {
                    errors.push(
                        this.$accountNumberErrors.data('errorIdenticalOriginalNumbers')
                            .replace('{number}', exactMatch)
                    );
                });

                // Add errors for similar matches
                similarMatches.forEach(({ formattedMatch, originalMatches }) => {
                    errors.push(
                        this.$accountNumberErrors.data('errorIdenticalParsedNumbers')
                            .replace('{parsedNumber}', formattedMatch)
                            .replace('{originalNumbers}', originalMatches.join(', '))
                    );
                });

                // If we have errors, show them
                if (errors.length > 0) {
                    this.error = true;
                    this.$accountNumber.addClass('error');
                    this.$accountNumberErrors.removeClass('hide');
                    this.$accountNumberErrors.html(
                        errors.map(
                            error => `<li>${error}</li>`
                        )
                    );
                }

                // If there aren't errors, clear them and store the formatted value
                else {
                    // Only update the value if there are no form errors;
                    // if we don't have this, the field is autoformatted
                    // and the UX can be quite jarring.
                    //
                    // The value will be submitted during the form submission
                    // in the submitForm function.
                    if (!this.error) {
                        this.$accountNumber.data('formattedValue', formattedAccountNumbers.join(', '));
                    }

                    this.$accountNumber.removeClass('error');
                    this.$accountNumberErrors.addClass('hide');
                    this.$accountNumberErrors.html('');
                }
            }
        },

        /**
         * Show the main error when showing all errors on the form.
         */
        hasError() {
            $(this.mainError).show();
            ws.views.form.prototype.hasError.call(this);
        },

        /**
         * Get all the elements name with error in the form
         * @returns {Array}
         */
        getFormErrorsNames() {
            // get all mandatory fields with error
            let errorsArr = $.makeArray(this.$('.mandatory:visible.error').map(function (i, el) {
                return $(el).attr('name');
            }));

            // check for terms and conditions
            if (this.$('.gta-terms-error').is(':visible')) {
                errorsArr.push('termsAndConditions');
            }

            // check for primary job function
            if (this.$('input[name="primaryJobFunction"]:not(:disabled)').val() === '') {
                errorsArr.push('primaryJobFunction');
            }

            return errorsArr.length ? errorsArr : ['other'];
        },

        /**
         * Form Submit Fail
         * Push entry to Google dataLayer on form submit fail
         */
        onFormSubmitFail() {
            this.gtmRegistrationForm(
                this.GTM_EVENT_ACTION_FAIL,
                this.getFormErrorsNames().join('_'),
                this.$country.find('option:selected').text().trim(),
                this.salesOrg
            );
        },

        /**
         * executes google analytics method to track registration form
         * @param {string} eventAction
         * @param {string} eventLabel
         * @param {string} country
         * @param {string} salesOrg
         */
        gtmRegistrationForm: function (eventAction, eventLabel, country, salesOrg) {
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = this.GTM_EVENT_CATEGORY;
            this.eventDataLayer.eventAction = eventAction;
            this.eventDataLayer.eventLabel = eventLabel;
            this.eventDataLayer.country = country;

            // jscs:disable
            this.eventDataLayer.sales_org = salesOrg;
            // jscs:disable

            this.logGTMEvent();
        },

        /**
         * Checks if form has errors
         * Execute dataLayer fail entry
         */
        checkErrorAndSubmit() {
            if (this.error === true) {
                this.onFormSubmitFail();
            }

            ws.views.form.prototype.checkErrorAndSubmit.call(this);
        },

        /**
         * overrides submit form to log analytics event
         */
        submitForm() {
            /**
             * Move the name attribute to a hidden input.
             * This is done so the form can submit
             * the formatted account number value
             * while the user doesn't see the formatted change.
             */
            const formattedValue = this.$accountNumber.data('formattedValue') || '';
            this.$accountNumber
                .removeAttr('name')
                .after(`<input name="accountNumber" type="hidden" value="${formattedValue}" />`);

            globals.disableApp();

            this.error = false;

            ws.views.form.prototype.submitForm.call(this);
        },

        /**
         * Highlight input element for custom errors
         */
        highlightInputForCustomError: function(helpInlineCollection){

                for(let item of helpInlineCollection){
                    $(item).parent().find('input').addClass(this.errorClass);
                }
        }

    });

})(westcon);
